<template>
	<div class="py-5">
		<div class="flex h-48 container mx-auto bg-gray-800">
			<div class="h-full w-48">
				<img
					src="https://www.sutter-nicolas.com/medias/moi.jpg"
					class="h-full w-full object-cover"
					alt=""
				/>
			</div>
			<div class="ml-3 pt-3">
				<h1 class="font-bold text-2xl uppercase text-gray-300">
					Le titre de l'album bitch
				</h1>
				<p class="text-gray-500">By: L'artiste in Année</p>
			</div>
		</div>
		<div class="container mx-auto mt-4">
			<div class="pl-48">
				<router-link to="/song">
					<div
						class="song rounded flex hover:bg-gray-800 justify-between py-2 px-3"
					>
						<p class="text-gray-400">1. Title qdfs qdsfqdq</p>
						<p class="text-gray-400">2:30</p>
					</div>
				</router-link>
				<router-link to="/song">
					<div
						class="song rounded flex hover:bg-gray-800 justify-between py-2 px-3"
					>
						<p class="text-gray-400">1. Title qdfs qdsfqdq</p>
						<p class="text-gray-400">2:30</p>
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Album'
};
</script>
